<template>
  <div class="pessoas-redefinir-senha-container">
    <v-card
      style="z-index: 4"
      class="pessoas-redefinir-senha-container1"
      elevation="8"
    >
      <div class="pessoas-redefinir-senha-header mt-3">
        <span>
          <v-icon color="tertiary" size="30" class="mr-2">
            mdi-key-variant
          </v-icon>
        </span>
        <h1>Cadastro de Afiliado</h1>
      </div>
      <v-form
        @submit.prevent="handleSubmit"
        class="pessoas-redefinir-senha-form"
      >
        <v-row class="mt-10 mb-1">
          <BaseTextField
            required
            label="Nome"
            v-model="fields.name"
            type="text"
            class="textinput"
            name="nome"
            tabindex="1"
          ></BaseTextField>
        </v-row>
        <v-row class="mb-1">
          <v-col class="pa-0 mr-4">
            <BaseTextField
              required
              label="E-mail"
              v-model="fields.email"
              type="text"
              class="textinput"
              name="nome"
              tabindex="1"
              :rules="[v => /.+@.+\..+/.test(v) || 'E-mail deve ser válido']"
              readonly
              hint="O email não pode ser alterado."
            ></BaseTextField>
          </v-col>
          <v-col class="pa-0">
            <BaseTextField
              required
              label="URL Personalizada"
              v-model="fields.slug"
              type="text"
              class="textinput"
              name="nome"
              tabindex="1"
              @input="formatSlug"
            ></BaseTextField>
          </v-col>
        </v-row>
        <v-row class="mb-2">
          <v-col class="pa-0 mr-4">
            <BaseTextField
              required
              label="CPF"
              v-model="fields.cpf"
              type="text"
              class="textinput"
              name="nome"
              tabindex="1"
              v-mask="'###.###.###-##'"
            ></BaseTextField>
          </v-col>
          <v-col class="pa-0">
            <BaseTextField
              required
              label="Telefone"
              v-model="fields.phone"
              type="text"
              class="textinput"
              name="nome"
              tabindex="1"
              v-mask="'(##) #####-####'"
            ></BaseTextField>
          </v-col>
        </v-row>
        <v-row class="mb-4">
          <BaseTextField
            label="Senha"
            required
            id="password"
            name="password"
            placeholder="******"
            v-model="fields.password"
            :type="showPass ? 'text' : 'password'"
            :append-icon="showPass ? $config.icons.viewOff : $config.icons.view"
            @click:append="showPass = !showPass"
            tabindex="2"
            autocomplete="new-password"
          ></BaseTextField>

          <PasswordRequirements :password="fields.password" />
        </v-row>
        <v-row>
          <BaseTextField
            label="Confirmar Senha"
            required
            id="confirmPassword"
            name="confirmPassword"
            placeholder="******"
            v-model="fields.confirmPassword"
            :type="showConfirmPass ? 'text' : 'password'"
            :append-icon="
              showConfirmPass ? $config.icons.viewOff : $config.icons.view
            "
            @click:append="showConfirmPass = !showConfirmPass"
            tabindex="3"
          ></BaseTextField>
        </v-row>
        <v-row class="justify-center align-center">
          <v-checkbox
            v-model="fields.termAccept"
            label="Li e concordo com os Termos de Uso e Privacidade."
            :color="$config.dados.primary"
          ></v-checkbox>
          <label
            style="
              font-size: 14px;
              margin-top: -2px;
              margin-left: 4px;
              text-decoration: underline;
              color: blue;
            "
            @click="dialog = true"
          >
            Clique aqui para visualizá-lo.
          </label>
        </v-row>
        <v-row>
          <v-btn
            height="45"
            class="button button-bg rounded-lg"
            block
            tabindex="4"
            type="submit"
          >
            <span>Cadastrar</span>
          </v-btn>
        </v-row>
      </v-form>
    </v-card>
    <waves />
    <v-dialog v-model="dialog" max-width="900px">
      <v-card class="pa-5">
        <h1 class="mb-4">Termo de aceite</h1>
        <v-card outlined>
          <vue-editor
            v-model="docTerm"
            class="termos-container-text-imagem-input"
            disabled
            :editorToolbar="customToolbar"
          >
          </vue-editor>
        </v-card>
        <v-row class="justify-end pa-3 mt-5">
          <v-btn
            height="48"
            class="btn-save"
            color="transparent"
            elevation="0"
            @click="dialog = false"
            :loading="registerLoading"
          >
            Fechar
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import waves from "@/components/global/waves.vue";
import BaseTextField from "@/components/forms/BaseTextField.vue";
import PasswordRequirements from "@/components/forms/PasswordRequirements.vue";
import { mapGetters, mapActions } from "vuex";
import { VueEditor } from "vue2-editor";
import {
  validatePasswordMinCharacters,
  validatePasswordMinLowerCase,
  validatePasswordMinNumbers,
  validatePasswordMinSpecialCharacters,
  validatePasswordMinUpperCase,
} from "../utils/index.js";
import { i18n } from "../main.js";

export default {
  name: "RegisterAffiliate",
  components: {
    waves,
    BaseTextField,
    VueEditor,
    PasswordRequirements,
  },
  metaInfo: {
    title: "Cadastro Afiliado | ElevenTickets",
    meta: [
      {
        property: "og:title",
        content: "Cadastro Afiliado | ElevenTickets",
      },
    ],
  },
  data() {
    return {
      fields: {
        name: "",
        email: "",
        slug: "",
        cpf: "",
        phone: "",
        password: "",
        confirmPassword: "",
        termAccept: false,
      },
      showPass: false,
      showConfirmPass: false,
      dialog: false,
      customToolbar: [],
    };
  },
  computed: {
    ...mapGetters(["docTerm", "dataPreRegister", "registerLoading"]),
  },
  methods: {
    ...mapActions([
      "showSnackbarError",
      "fetchDocTerm",
      "fetchInfoPreRegister",
      "registerAffiliate",
    ]),
    handleSubmit() {
      if (!this.fields.name) {
        this.showSnackbarError("Preencha o nome corretamente");
        return;
      }
      if (!this.fields.email) {
        this.showSnackbarError("Preencha o e-mail corretamente");
        return;
      }
      if (!this.fields.slug) {
        this.showSnackbarError("Preencha a URL personalizada corretamente");
        return;
      }
      if (this.fields.cpf.length < 14) {
        this.showSnackbarError("Preencha o CPF corretamente");
        return;
      }
      if (this.fields.phone.length < 15) {
        this.showSnackbarError("Preencha o telefone corretamente");
        return;
      }

      const password = this.fields.password;

      if (validatePasswordMinCharacters(password)) {
        this.showSnackbarError(
          i18n.t("common.password-requirements.error-messages.min-length")
        );
        return;
      }

      if (validatePasswordMinNumbers(password)) {
        this.showSnackbarError(
          i18n.t("common.password-requirements.error-messages.min-numbers")
        );
        return;
      }

      if (validatePasswordMinLowerCase(password)) {
        this.showSnackbarError(
          i18n.t(
            "common.password-requirements.error-messages.min-non-capital-characters"
          )
        );
        return;
      }

      if (validatePasswordMinUpperCase(password)) {
        this.showSnackbarError(
          i18n.t(
            "common.password-requirements.error-messages.min-capital-characters"
          )
        );
        return;
      }

      if (validatePasswordMinSpecialCharacters(password)) {
        this.showSnackbarError(
          i18n.t(
            "common.password-requirements.error-messages.min-special-characters"
          )
        );
        return;
      }
      if (this.fields.password != this.fields.confirmPassword) {
        this.showSnackbarError("As senhas não coincidem.");
        return;
      }
      if (!this.fields.termAccept) {
        this.showSnackbarError("Você deve aceitar os termos de uso.");
        return;
      }
      this.registerAffiliate({
        idprogramaafiliado: this.$router.history.current.params.id,
        nome: this.fields.name,
        email: this.fields.email,
        telefone: this.fields.phone,
        cpf: this.fields.cpf,
        slug: this.fields.slug,
        senha: this.fields.password,
        termo: new Date(),
      });
    },
    formatSlug() {
      this.fields.slug = this.fields.slug
        .toLowerCase()
        .replace(/\s+/g, "-")
        .replace(/[^a-z0-9-]/g, "");
    },
  },
  watch: {
    "$store.getters.dataPreRegister"(val) {
      if (val) {
        this.fields.name = val.nome;
        this.fields.slug = val.slug;
        this.fields.email = val.email;
        this.fields.cpf = val.cpf;
        this.fields.phone = val.telefone;
      }
    },
  },
  mounted() {
    this.fetchDocTerm();
    this.fetchInfoPreRegister({ id: this.$router.history.current.params.id });
  },
};
</script>

<style scoped>
.pessoas-redefinir-senha-container {
  width: 100%;
  display: flex;
  min-height: 100vh;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  padding: 10px;
}

.pessoas-redefinir-senha-container1 {
  width: 750px;
  height: auto;
  padding: 2rem;
  display: flex;
  flex-direction: column;
  border-radius: 16px;
  z-index: 3;
}

.pessoas-redefinir-senha-header {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.pessoas-redefinir-senha-form {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0.625rem;
}

.back-button {
  position: absolute;
  top: 0;
  left: 0;
}
</style>
